import React from 'react';
import { Flex, Row } from 'antd';
import { TransactionOutlined, OrderedListOutlined, ArrowsAltOutlined } from '@ant-design/icons';
import can from '../../components/ability';
import NavItem from '../../components/nav-item';
import ProxyList from './list';
import SwitchShop from '../shop/switch-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        <Row gap={20} style={{ margin: '10px 0 0 0' }}>

            {
                can('proxy', 'goods') && <NavItem href="/goods/proxy" text="代理商品">
                    <TransactionOutlined style={iconStyle} />
                </NavItem>
            }

            <NavItem href="/shop/level-partner" text="代理等级管理">
                <OrderedListOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/shop/level-user" text="分销等级管理">
                <OrderedListOutlined style={iconStyle} />
            </NavItem>
        </Row>
        <h2>我的销售网</h2>
        <ProxyList />
    </div>
  )
}